
    import { Component, Vue } from 'vue-property-decorator';
    import { ITag } from '@/interfaces/Tags/ITag';
    import { IFile } from '@/interfaces/Files/IFile';
    import tagsAPI from '@/store/tagsAPI';
    import filesAPI from '@/store/filesAPI';
    import homepagefileandlinkAPI from '@/store/homepagefileandlinkAPI';
    import Multiselect from 'vue-multiselect'
    @Component({
        components: {
            Multiselect
        }
    })
    export default class Home extends Vue {
        private Allfiles: any = [] as Array<IFile>;
        private homefiles: any = [] as Array<IFile>;
        private TagTypeSelected = [] as Array<ITag>;
        private alltags = [] as Array<ITag>;
        private drpbiome = [] as Array<ITag>;
        private drpenv = [] as Array<ITag>;
        private drpnooftaxa = [] as Array<ITag>;
        private drpnooflinks = [] as Array<ITag>;
        private drpcontinent = [] as Array<ITag>;
        private drpdominant = [] as Array<ITag>;
        private drpincludeparasite = [] as Array<ITag>;
        private drpyearofcollection = [] as Array<ITag>;
        private drptaxonomic = [] as Array<ITag>;

        private selectedbiome = [] as Array<ITag>;
        private selectedenv = [] as Array<ITag>;
        private selectednooftaxa = [] as Array<ITag>;
        private selectednooflinks = [] as Array<ITag>;
        private selectedcontinent = [] as Array<ITag>;
        private selectedpdominant = [] as Array<ITag>;
        private selectedincludeparasite = [] as Array<ITag>;
        private selectedyearofcollection = [] as Array<ITag>;
        private selectedtaxonomic = [] as Array<ITag>;

        private downloadFile(fileid: any, fileName: string) {
            
            filesAPI.downloadFile(fileid, fileName);
        }

        private downloadHeaderFile(fileid: any, fileName: string) {
           
            homepagefileandlinkAPI.downloadFile(fileid, fileName);
        }

        private async on_search() {
            this.TagTypeSelected = this.selectedbiome.concat(this.selectedenv)
                .concat(this.selectednooftaxa)
                .concat(this.selectednooflinks)
                .concat(this.selectedcontinent)
                .concat(this.selectedpdominant)
                .concat(this.selectedincludeparasite)
                .concat(this.selectedyearofcollection)
                .concat(this.selectedtaxonomic)

            if (this.TagTypeSelected != null && this.TagTypeSelected.length > 0) {
                let formData: FormData = new FormData();
                formData.append('tags', JSON.stringify(this.TagTypeSelected));

                this.Allfiles = await filesAPI.getfileselected(formData);
            }
        }

        private short(string: string) {
            const len = 10;
            return string.substring(0, len + string.substring(len - 1).indexOf(' '));

        }

        private downloadAllFiles() {
            console.log(this.TagTypeSelected);
            let formData: FormData = new FormData();
            if (this.TagTypeSelected.length>0)
                formData.append('tags', JSON.stringify(this.TagTypeSelected));
            else {
                formData.append('tags', JSON.stringify(this.alltags)); 
            }
            filesAPI.downloadAllFiles(formData);
        }
        
        private async getallfiles() {
            this.Allfiles = await filesAPI.getfiles();
        }
        private async mounted() {
            this.drpbiome = await tagsAPI.getTags(21);
            this.drpenv = await tagsAPI.getTags(22);
            this.drpnooftaxa = await tagsAPI.getTags(23);
            this.drpnooflinks = await tagsAPI.getTags(24);
            this.drpcontinent = await tagsAPI.getTags(25);
            this.drpdominant = await tagsAPI.getTags(26);
            this.drpincludeparasite = await tagsAPI.getTags(27);
            this.drpyearofcollection = await tagsAPI.getTags(28);
            this.drptaxonomic = await tagsAPI.getTags(29);

           // this.getallfiles();
            this.alltags = await tagsAPI.getAllTags();
            this.homefiles = await homepagefileandlinkAPI.gethomepagefiles();
            //console.log(this.tags)
        }
    }
